/**
 * @generated SignedSource<<2cf2acb53d9f90aac5571348b66c5860>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSharedSellerDetails_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ContactDealerInlineForm_viewer" | "PdpSharedSellerDetailsHeader_viewer" | "PdpSharedSellerDetailsReviewContainer_viewer" | "PdpSharedSellerInfo_viewer" | "PdpSharedSellerTabs_viewer">;
  readonly " $fragmentType": "PdpRespSharedSellerDetails_viewer";
};
export type PdpRespSharedSellerDetails_viewer$key = {
  readonly " $data"?: PdpRespSharedSellerDetails_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedSellerDetails_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSharedSellerDetails_viewer",
  "selections": [
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ContactDealerInlineForm_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedSellerTabs_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedSellerDetailsReviewContainer_viewer"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSellerDetailsHeader_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSellerInfo_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "5eb2c0b06bb9fccc9083acee97aa9eb2";

export default node;
